import styled, { css } from "styled-components";

interface ChipProps {
  type: "blue" | "gray" | "line";
  size: "xs" | "s";
  width: string;
}

export const StyledRegacy__Chip = styled.div<ChipProps>`
  height: max-content;
  max-width: ${(props) => props.width};
  span.chip {
    width: 100%;
    padding: 0.4rem;
    display: inline-flex;
    flex-wrap: nowrap;
    align-items: center;
    outline: none;
    border: none;
    gap: 0.2rem;
    border-radius: 0.4rem;
    box-sizing: border-box;

    .label {
      white-space: nowrap;

      text-overflow: ellipsis;
    }

    ${(props) =>
      props.size === "s" &&
      css`
        padding: 0.4rem 0.8rem;
        & > .label {
          font: var(--body-small-400);
          color: var(--pri-blue-7);
        }
      `}

    ${(props) =>
      props.size === "xs" &&
      css`
        padding: 0.4rem;
        & > .label {
          font: var(--label-small-400);
          color: var(--pri-blue-7);
          &.red {
            color: var(--sys-red-1) !important;
          }
        }
      `}

    ${(props) =>
      props.type === "blue" &&
      css`
        background-color: var(--pri-blue-2);
      `};

    ${(props) =>
      props.type === "gray" &&
      css`
        background-color: var(--bg-gray-1);
        padding: 0.4rem 0.8rem;
      `};
    ${(props) =>
      props.type === "line" &&
      css`
        box-sizing: border-box;
        background-color: transparent;
        border: 0.1rem solid var(--pri-blue-7);
      `};

    cursor: default;
    & > button {
      display: flex;
      align-items: center;
      border: none;
      outline: none;
      padding: 0;
      background-color: transparent;
      width: 1rem;
      height: 1rem;
      cursor: pointer;
      margin-left: 0.2rem;
      display: flex;

      &.sort {
        display: flex;
        align-items: center;
        width: auto !important;
        height: auto !important;
        font: var(--label-small-600);
        color: var(--text-gray-normal);
        margin-left: 0.4rem;

        .sort-icon-wrap {
          transition: all 0.2s ease;
          display: flex;
          & > svg {
            width: 1rem;
            height: 1rem;
          }
        }

        &.asc .sort-icon-wrap {
          transform: rotate(180deg);
        }

        &.desc .sort-icon-wrap {
          transform: rotate(0deg);
        }
      }

      &.delete-btn {
        svg {
          width: 1rem;
          height: 1rem;
          path {
            stroke: var(--pri-blue-7);
          }
        }
      }
    }
  }
`;
